import { render, staticRenderFns } from "./evaluationType.vue?vue&type=template&id=40f7e84a&scoped=true&"
import script from "./evaluationType.vue?vue&type=script&lang=js&"
export * from "./evaluationType.vue?vue&type=script&lang=js&"
import style0 from "./evaluationType.vue?vue&type=style&index=0&id=40f7e84a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f7e84a",
  null
  
)

export default component.exports